module.exports = __webpack_public_path__ + "img/error-dark.1aa1b73f.svg";